module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"QuoteBlock":{"quoteImageAltText":"Uvozovky"}},"de":{"QuoteBlock":{"quoteImageAltText":"Anführungszeichen"}},"sk":{"QuoteBlock":{"quoteImageAltText":"Úvodzovky"}}}')
  delete Component.options._Ctor
}
